<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <ItemsWaiting v-if="is_fetch" />
    <div v-else style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex justify-content-between">
        <div class="text-right m-4">
          <h5 style="font-size: 1vw !important"> اولویت بندی مسئله </h5>
        </div>
        <div  class="d-flex" v-if="allItems.length" >
          <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1" v-if="seconder_ban || approver_ban" v-show="!status_show" @click="infoCancelledModal=true">   دلایل عدم تایید</a>


<!--          <a   :href="`${this.download_url}/PrioritizingIssue/all/pdf/by/id/${id_user}?token=${$cookies.get('id_login')}`"
             style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
            PDF</a>-->

        </div>


      </div>
      <center v-if="status_approver">
        <div   class="alert alert-success w-25">
          تایید نهایی!
        </div>
      </center>
            <center v-if="!status_show && allItems.length">

        <div v-if="seconder_ban"  class="alert alert-warning w-50" @click="infoCancelledModal=true" >
          <div v-if="this.$cookies.isKey('type_2')">
            کاربرگ توسط مدیر ؛ تایید نشد!
          </div>
          <div v-else>
            این کاربرگ قبلا توسط شما رد شده است و الان اصلاح شده است!

          </div>
        </div>
      </center>
      <center v-if="!status_show">
        <div v-if="approver_ban" @click="infoCancelledModal=true"  class="alert alert-info" style="width: 30vw;">
          کاربرگ توسط مدیر سامانه ؛ تایید نشد!
        </div>
      </center>
      <center   v-if="status_seconder_step">
        <div v-if="status_seconder" class="alert alert-info w-25">
          در انتظار تایید توسط مدیر
        </div>
        <div v-if="!status_seconder" class="alert alert-info" style="width: 24vw;">
          در انتظار تایید توسط مدیر سامانه
        </div>
      </center>
      <div class="table-responsive p-5">
        <center v-show="!allItems.length">
          <span v-if="$cookies.isKey('type_2') && isWrite">اولویت بندی مسئله وجود ندارد</span>
          <span v-else-if="!isWrite">دوره ای برای  پایش بهره وری این شرکت فعال نمی باشد
</span>
          <span v-else>
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table v-show="allItems.length" class="table table-striped">
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>


            <th rowspan="2"><strong>مسئله</strong></th>
            <th colspan="6"><strong>نماگر وضعیت مسئله</strong></th>
          </tr>
          <tr>
            <th>امتیاز جذابیت
              (از 1)
            </th>
            <th>امتیاز توانمندی
              (از 1)
            </th>
            <th>امتیاز نهایی مسئله
              (از 1)
            </th>
            <th v-if="true">اولویت مسئله</th>
            <th>
            انتخاب مسئله اولویت دار
            </th>
            <th>مستندات</th>


          </tr>
          <tr style="background-color: #fff;" v-for="(item, index) in allItems">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title }}</td>
            <td >
              <div class="d-flex">
                <formula v-if="show_insert" @click="fxOneMethod(item.title, item.id)" class="mx-2"/>
                <input :value="item.prioritizing_issue && item.prioritizing_issue.attractiveness_soccer" :id="`inputFxOne_${item.id}`" :data-number="item.id" @keyup="checkValueFxOne" type="number" max="1"
                       min="0" class="form-control number_size">
              </div>
            </td>

            <td>
              <div class="d-flex">
                <formula v-if="show_insert" @click="fxTwoMethod(item.title, item.id)" class="mx-2"/>
                <input :value="item.prioritizing_issue && item.prioritizing_issue.ability_soccer" :id="`inputFxTwo_${item.id}`" :data-number="item.id" @keyup="checkValueFxTwo" type="number"
                       max="1" min="0" class="form-control number_size">
              </div>
            </td>
            <td ><input readonly :id="`result_${item.id}`"
                       type="text"
                       :value="item.prioritizing_issue && item.prioritizing_issue.result_soccer"
                       class="form-control number_size"></td>
            <td v-if="true"><input
                :value="item.prioritizing_issue && item.prioritizing_issue.order"
                :id='`order_${item.id}`' type="number" class="form-control number_size"></td>
            <td ><input

                :value="1"
                :checked="item.prioritizing_issue && item.prioritizing_issue.is_show"
                :id='`is_show_${item.id}`' type="checkbox" style="transform: translateY(0.4vw); width: 1.5vw; height: 1.5vw;"></td>

            <td>
              <p @click.prevent="AddDocumentMethod(item.id,item.title)" class="btn p-2 btn-submit-1 btn-primary">آپلود مستندات</p>
            </td>
          </tr>



          </tbody>
        </table>
      </div>

      </div>
      <center v-if="show_insert && not_show">
        <button
            v-show="allItems.length"
            @click="store"
           style="margin-top: 1.3vw;margin-left: 2vw;  margin-bottom: 1vw;" class="btn btn-primary btn-submit-1">ذخیره
           </button>
      </center>
      <br>
      <hr v-if="allItems.length">
      <div v-if="allItems.length" class="d-flex align-items-center justify-content-center mb-4">
        <a   :href="`${this.download_url}/PrioritizingIssue/all/word/by/id/${id_user}?token=${$cookies.get('id_login')}`" style="margin-left: 2vw;margin-top: 1.3vw;"
             class="btn btn-primary btn-submit-1">خروجی Word</a>
        <p @click.prevent="exportDocs"   style="margin-left: 2vw;margin-top: 2.5vw;"
             class="btn btn-primary btn-submit-1">خروجی مستندات</p>
        <a
            v-if="not_show"
            :style="$cookies.isKey('type_2') ? 'width: 10vw': ''"
            style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green" class="btn btn-primary btn-submit-1 "


        >
          <div v-if="!status_loading">

            <span  @click="acceptComplete" v-if="!$cookies.isKey('type_2')">  تایید </span>
            <span  @click="acceptCompleteModal=true" v-else>    ارائه جهت تایید مدیر</span>

          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
        <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal" style="z-index: 999999999999999; top: 40%;">
          <div>
            <p>اخطار</p>
            <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
          </div>
          <div>
            <p>آیا از ارائه به مدیر مطمئن هستید؟</p>

            <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
              <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
              <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
            </div>
          </div>
        </div>
        <a v-if="!$cookies.isKey('type_2') && not_show"   style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  " class="btn btn-primary btn-submit-1 "
           @click="acceptComplete2"
        >
          <div v-if="!status_loading2">
            <span >عدم تایید</span>
          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
      </div>


      <div v-show="fxOne" class="modal__error slide-top" style="width: 80vw; z-index: 9999">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th style="width: 1vw;"><strong>ردیف</strong></th>


            <th><strong>توانمندی</strong></th>
            <th style="width: 1vw;"><strong>وزن </strong></th>
            <th  ><strong> {{title}} </strong></th>



          </tr>
          <tr>
            <td>1</td>
            <td>دسترسی به فناوری (امتیاز)</td>
            <td>0.2</td>
            <td><input v-model="num1" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>2</td>
            <td>منابع مالی موجود (م. ریال )</td>
            <td>0.3</td>
            <td><input  v-model="num2" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>3</td>
            <td>سرمایه انسانی متخصص (نفر)</td>
            <td>0.3</td>
            <td><input  v-model="num3" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>4</td>
            <td>مکانات و زیرساخت (امتیاز)</td>
            <td>0.2</td>
            <td><input  v-model="num4" type="number" class="form-control"></td>
            </tr>

          </tbody>
        </table>
        <center>
          <button
            @click="calcOne"
             style="margin-top: 1.3vw;margin-left: 2vw; margin-right: 1vw;"  class="btn btn-primary btn-submit-1">ذخیره

             </button>
        </center>
      </div>

      <div v-show="fxTwo" class="modal__error slide-top" style="width: 80vw; z-index: 9999">

        <table class="table table-striped">
          <tbody>
          <tr>
            <th style="width: 1vw;"><strong>ردیف</strong></th>


            <th><strong>جذابیت</strong></th>
            <th style="width: 1vw;"><strong>وزن </strong></th>
            <th  ><strong> {{title}} </strong></th>



          </tr>
          <tr>
            <td>1</td>
            <td>خلق ارزش عمومی (امتیاز)</td>
            <td>0.4</td>
            <td><input  v-model="num1" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>2</td>
            <td>صرفهجویی بودجه (م. ریال)</td>
            <td>0.3</td>
            <td><input  v-model="num2" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>3</td>
            <td>مدت زمان بازگشت سرمایه (سال)</td>
            <td>0.3</td>
            <td><input  v-model="num3" type="number" class="form-control"></td>

          </tr>

          </tbody>
        </table>
        <center>
          <button
              @click="calcTwo"
              style="margin-top: 1.3vw;margin-left: 2vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ذخیره
          </button>
        </center>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>دلایل عدم تایید</p>
      <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
    </div>
    <div>
        <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{textAlert}}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
      <p @click="showReSubmit=!showReSubmit">❌</p>
    </div>
    <div>
        <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{textAlert}}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button @click="acceptComplete4"  class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
      </div>
    </div>
  </div>
  <div class="modal__error bg-white" style="z-index: 9699; direction: rtl; width: 54vw; overflow-y: scroll; height: 35vw;" v-show="documentsModal">
    <div  class="d-flex justify-content-between">
      <p>مستندات</p>
      <p id="btn2_p" @click.prevent="closeModal()">❌</p>
    </div>
    <hr>
    <div class="d-flex flex-column" v-if="not_show && show_insert">
      <label class="required text-end">     عنوان مستندات پیوست  </label>
      <input id="title" v-model="title_attach" type="text" class="form-control">
    </div>
    <div class="d-flex flex-column" v-if="not_show && show_insert">
  <label class="required text-end">فایل پیوست</label>
  <label class="input input--file">
    <input
      id="file"
      type="file"
      class="input__field"
      accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .csv"
      required
      @change="handleFileChange"
    >
    <span class="input__support">
      <span STYLE="color: #7d8a96;direction: ltr;" class="input__helper">{{ file_name }}</span>
    </span>
  </label>
</div>

    <div id="showBar" style="display:none;">
      <div class="progress">
        <div class="progress-bar" role="progressbar" id="progress_bar"  :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <p id="progress"></p>
    </div>
    <center class="my-2" v-if="not_show">
      <button id="btn_p" @click="addDocs" class="btn btn-primary btn-submit-1">افزودن </button>
      <hr class="my-3 w-100" v-if="show_insert">
    </center>
    <div style="font-size: 1vw;color: #a7a3a3;" v-if="isLoadingDocuments" class="text-center my-3">در حال دریافت اطلاعات...</div>
    <div style="font-size: 1vw;color: #a7a3a3;" v-else-if="!documents.length" class="text-center my-3">موردی یافت نشد!</div>
    
    <table  class="table table-striped bg-white" v-else>
      <thead >
      <tr>
        <th ><strong> عنوان مستند    </strong></th>
        <th><strong>فایل مستند</strong></th>
        <th v-if="show_insert" style="width: 1vw;"><strong>عملیات  </strong></th>
      </tr>
      </thead>
      <tbody>

      <tr class="bg-white" v-for="(item) in documents">
        <td>{{item.text}}</td>
        <td>
          <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
        </td>
        <td v-if="show_insert">
          <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>

        </td>
      </tr>
      </tbody>


    </table>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="delete_fileModal=!delete_fileModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import {useToast} from "vue-toastification";
import Formula from "@/components/images/formula.vue";
import login from "@/views/auth/Login.vue";
import router from "@/router";
import ItemsWaiting from "@/components/Loaders/ItemsWaiting.vue";

const toast = useToast();

export default {
  computed: {},
  components: {
    ItemsWaiting,
    Formula,
    Sidebar,
    splash
  },
  data() {
    return {
      documents: [],
      isLoadingDocuments: false,
      status_loading2: false,
      showReSubmit: false,
      allItems: [],
      fxOne: false,
      fxTwo: false,
      title: '',
      id: '',
      documentsModal: false,
      num1: '',
      num2: '',
      num3: '',
      num4: '',
      id_user: '',
      acceptCompleteModal: false,
      is_fetch: true,
      status_show: false,
      isWrite: false,
      status_loading: false,
      show_insert: false,
      status_seconder: false,
      status_approver: false,
      infoCancelled: false,
      text_info: '',
      seconder_ban: false,
      approver_ban: false,
      textAlert: '',
      title_attach: '',
      id_file: '',
      progress: '',
      infoCancelledModal: false,
      status_seconder_step: false,
      delete_fileModal: false,
      not_show: true,
      title_attach: '',
    file_name: '',


    }
  },
  methods: {
    exportDocs() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Prioritizing_Issue/export_doc`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.download_link) {
              // ایجاد یک المان a مخفی برای دانلود
              const link = document.createElement('a');
              link.href = response.download_link;
              link.download = 'documents.zip'; // یا هر نام دیگری که می‌خواهید
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              toast.info('دانلود شروع شد');
            } else if (response.error) {

              // نمایش پیام خطا به کاربر
              toast.error('خطا در دریافت فایل: ' + response.error);
            }
          })
          .catch(error => {
             toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },
    deleteMethodFileSubmit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Prioritizing_Issue/remove_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message){
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    allDocsMethod(id){

      
      this.isLoadingDocuments = true;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/all_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.isLoadingDocuments = false;
            if (response.error) {
              toast.error(response.error)
              
              return
            }
            this.documents.length=0
            response.all.forEach((item)=>{
              this.documents.push(item)
              this.isLoadingDocuments = false;
            })



          })
          .catch();
    },
    deleteMethodFile(id){
      this.id_file = id
      this.delete_fileModal = true
    },
    addDocs() {
  const token = this.$cookies.get('token');
  const file = document.querySelector('#file').files[0];
  const title = this.title_attach;

  if (!file || !title) {
    toast.error('عنوان و فایل الزامی هستند');
    return;
  }

  const formdata = new FormData();
  formdata.append('text', title);
  formdata.append('file', file);
  formdata.append('id', this.id);

  const xhr = new XMLHttpRequest();
  xhr.open('POST', `${this.base_url}/Prioritizing_Issue/add_doc`, true);

  // Header
  xhr.setRequestHeader('Authorization', `Bearer ${token}`);

  // Progress
  xhr.upload.onprogress = (event) => {
    if (event.lengthComputable) {
      const progress = ((event.loaded / event.total) * 100).toFixed();
      this.progress = progress;
      document.getElementById("showBar").style.display = 'block';
      document.getElementById("btn2_p").style.visibility = 'hidden';
      document.getElementById("btn_p").style.visibility = 'hidden';
      document.getElementById("progress").innerText = `${progress}%`;
      document.getElementById("progress_bar").style.width = `${progress}%`;
    }
  };

  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      document.getElementById("showBar").style.display = 'none';
      document.getElementById("btn2_p").style.visibility = 'visible';
      document.getElementById("btn_p").style.visibility = 'visible';

      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        if (response.error) {
          toast.error(response.error);
        } else {
          toast.success(response.message);
          this.file_name = '';
          // پاک کردن مقادیر
          this.title_attach = '';
          document.querySelector('#title').value = '';
          document.querySelector('#file').value = '';

          // بروزرسانی لیست مستندات
          this.allDocsMethod(this.id);
        }
      } else {
        console.error('Upload error:', xhr.status);
        toast.error('خطا در آپلود فایل');
      }
    }
  };

  xhr.send(formdata);
}
,
closeModal(){
  
    this.documentsModal=!this.documentsModal ; 
    this.title_attach="";
    this.file_name = '';
     document.querySelector('#title').value = '';
          document.querySelector('#file').value = '';
          this.documents.length=0
},
 handleFileChange(event) {
    const file = event.target.files[0];
    this.file_name = file ? file.name : '';
  },
    AddDocumentMethod(id,title){
      this.documentsModal = true
      this.id = id
      this.allDocsMethod(id)
    },






    setShow(){
      if (this.$cookies.isKey('type_2')){
        if (this.status_show===false){
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete(){
      this.acceptCompleteModal = false
      if (this.status_show ){
        return;
      }
      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      if (this.seconder_ban || this.approver_ban){
        this.showReSubmit=true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    acceptComplete4(){
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false
            this.showReSubmit = false

          })
          .catch();
    },
    acceptComplete2(){

      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3(){
      this.status_loading2 = true
      if (!this.status_show){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info){
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/Prioritizing_Issue/update_complete`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    calcOne(){
      this.fxOne=!this.fxOne

    },
    calcTwo(){
      this.fxTwo=!this.fxTwo

    },
    fxOneMethod(title,id){
      this.fxOne=!this.fxOne
      this.title = title
      this.id = id
    },
    fxTwoMethod(title,id){
      this.fxTwo=!this.fxTwo
      this.title = title
      this.id = id

    },
    CalcNumber(num1, num2, id) {
      const one = document.getElementById(num1);
      const two = document.getElementById(num2);

      // حاصل‌ضرب را محاسبه
      const result = parseFloat(one.value) * parseFloat(two.value);

      // اگر حاصل‌ضرب کمتر از صفر باشد، خروجی را صفر قرار دهید
      const finalResult = result < 0 ? 0 : result;

      // تعداد اعشار را به 2 محدود کنید
      const resultWithTwoDecimal = finalResult.toFixed(2);

      // خروجی را در المان مربوطه قرار دهید
      document.querySelector(`#result_${id}`).value = resultWithTwoDecimal;
    },

    checkValueFxOne(event) {
      const inputValue = parseFloat(event.target.value);
      if (inputValue > 1) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'
        return false;

      } else if (inputValue < 0) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'

        return false;

      }
      document.querySelector(`#${event.target.id}`).style.border = '1px solid #777'
      return this.CalcNumber(`inputFxTwo_${event.target.dataset.number}`, `inputFxOne_${event.target.dataset.number}`,  event.target.dataset.number)


    },
    checkValueFxTwo(event) {
      const inputValue = parseFloat(event.target.value);
      if (inputValue > 1) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'
        return false;

      } else if (inputValue < 0) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'

        return false;

      }
      document.querySelector(`#${event.target.id}`).style.border = '1px solid #777'
      return this.CalcNumber(`inputFxTwo_${event.target.dataset.number}`, `inputFxOne_${event.target.dataset.number}`,  event.target.dataset.number)

    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.status_seconder =false
            this.seconder_ban = false
            this.approver_ban = false
            this.status_approver = false
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {
              this.allItems.push(item)

            })
            this.is_fetch = false
            this.setShow()
            if (!response.status_seconder){
              if (response.status){
                this.status_seconder = true
              }
            }
            if (!this.status_approver && this.$cookies.isKey('type_1')){
              this.status_seconder = false
            }
            if (response.status && !response.status_approver){
              this.status_seconder = true
            }
            if (response.seconder_ban){
              this.seconder_ban = true
              this.textAlert = response.message??'موردی یافت نشد'
            }
            if (response.approver_ban){
              this.approver_ban = true
              this.textAlert = response.message??'موردی یافت نشد'
            }

            if (response.status_approver){
              this.status_approver = true
            }
            if (response.text_seconder){
              this.seconder_ban = true
              this.textAlert = response.text_seconder??'موردی یافت نشد'
            }
            if (parseInt(response.step)===1){
              this.status_seconder_step=true
              this.status_seconder=true
            }
            if (parseInt(response.step)===2){
              this.status_seconder_step=true
              this.status_seconder=false
            }  if (parseInt(response.step)===0){
              this.status_seconder_step=false

            }
            this.show_insert = response.status_insert
            if ((parseInt(response.step)===1&&this.type_two)||(parseInt(response.step)===2&&this.type_two) || (parseInt(response.step)===2&&this.type_one) || parseInt(response.step)===3){
              this.not_show = false
            }
          })
          .catch();
    },
    store(){
      let obj = []
      this.allItems.forEach((ele)=>{
        const fxOne = document.getElementById(`inputFxOne_${ele.id}`).value
        const fxTwo = document.getElementById(`inputFxTwo_${ele.id}`).value
        const result =  document.getElementById(`result_${ele.id}`).value
        const order =  document.getElementById(`order_${ele.id}`).value
        const is_show =  document.getElementById(`is_show_${ele.id}`).checked ? 1 : 0
        const item = {
          'problem_identifications_id': ele.id,
          'attractiveness_soccer': fxOne,
          'ability_soccer': fxTwo,
          'result_soccer': result,
          'order': order,
          'is_show': is_show,
          'id': ele.prioritizing_issue ? ele.prioritizing_issue.id : null
        }
        obj.push(item)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.all()

          })
          .catch();

    },
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    ProductivityPeriod(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ProductivityPeriod/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.status){
              this.isWrite = true
              return
            }else{
              this.isWrite = false
            }



          })
          .catch();
    },

  },
  mounted() {
    this.all()
    this.checkIsMother()
    this.fetchItems()
    this.ProductivityPeriod()
  },

}
</script>
<style scoped lang="scss">
tr {
  background-color: #fff;
}
.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}

.input:hover .input__support {
  border-color: #9fa8b2;
}
.input:hover .input__support:before {
  color: #7d8a96;
}
.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}
.input__text sup {
  color: #fe4f3e;
  cursor: help;
}
.input .input__support:before {
  display: none;

}
.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__field:focus + .input__support {
  border-color: #037DE4;
}
.input__field:valid + .input__support {
  border-color: #3742FA;
}
.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}
.input__field:valid + .input__support .input__helper:before {
  content: " ";
  color: #7d8a96;
}
.input__field:invalid + .input__support:before {
  content: "file_upload";
}
.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}
.input__support {
  display: flex !important;
  align-items: center;
}
.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}
.input--file {
  cursor: pointer;
}
.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}
.number_size{
  width: 5vw;
  text-align: center;
}
</style>